import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import {
  Container,
  Button,
  Dropdown,
  Form,
  OverlayTrigger,
  Tooltip,
  Spinner,
} from "react-bootstrap";
import { HidSelector } from "../../../../Common/Components/HidSelector";
import { OperationalBudgetsDetails } from "./OperationalBudgetsDetails";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { SingleSelectDropDown } from "../../../../Common/Components/SingleSelectDropDown";
import { MultiSelectDropDown } from "../../../../Common/Components/MultiSelectDropDown";
import TableSearch from "../../../../Common/Components/TableSearch";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import "../budgets.scss";
export class OperationalBudgets extends React.Component<any, any> {
  private childHID: any;
  constructor(props: any) {
    super(props);
    this.childHID = React.createRef();
    this.state = {
      isOperationalBudgetsdetailsSlideOut: false,
      //dropdownItems: ["2025", "2024", "2023", "2022", "2021", "2020"],
      dropdownItems: [
        { value: "2025", eventKey: "2025" },
        { value: "2024", eventKey: "2024" },
        { value: "2023", eventKey: "2023" },
        { value: "2022", eventKey: "2022" },
        { value: "2021", eventKey: "2021" },
      ],
      StatusdropdownItems: [
        { value: "Locked", eventKey: "locked" },
        { value: "Unlocked", eventKey: "unlocked" },
      ],
      selectedStage: "",
      selectedYear: "",
      hotelName: "",
      hidValue: 0,
    };
  }
  selectHotelDropDown = (hotelDetails: any) => {
    this.setState({
      hotelName: hotelDetails.lettercode,
      hidValue: hotelDetails.hotelID,
    });
  };
  handleOperationalBudgetsdetails = (row, rowIndex) => {
    this.setState({
      isOperationalBudgetsdetailsSlideOut: true,
    });
  };
  OperationalBudgetsDetailsModal = (event) => {
    this.setState({ isOperationalBudgetsdetailsSlideOut: false });
  };
  handleYearSelect = (item) => {
    this.setState({ selectedYear: item.value });
  };
  handleStageSelect = (item) => {
    this.setState({ selectedStage: item.value });
  };
  handleMultiSelectChange = (selectedItems) => {
    console.log("Selected:", selectedItems);
  };

  render() {
    const items = [
      "Not Started",
      "In Progress",
      "Pending Approval",
      "Approved",
    ];
    const data = [
      {
        id: "1",
        ehid: "BWCA",
        year: "2025",
        stage: "Not Started",
        status: "Unlocked",
      },
      {
        id: "1",
        ehid: "BWCA",
        year: "2025",
        stage: "In Progress",
        status: "Unlocked",
      },
      {
        id: "1",
        ehid: "BWCA",
        year: "2025",
        stage: "Pending Approval",
        status: "Unlocked",
      },
      {
        id: "1",
        ehid: "BWCA",
        year: "2025",
        stage: "Approved",
        status: "Locked",
      },
    ];
    const columns = [
      {
        dataField: "ehid",
        text: "EHID",
      },
      {
        dataField: "year",
        text: "Year",
      },
      {
        dataField: "stage",
        text: "Stage",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <div
              className={`status ${row.stage == "Not Started" ? "grey" : ""} ${
                row.stage == "In Progress" ? "blue" : ""
              } ${row.stage == "Pending Approval" ? "orange" : ""} ${
                row.stage == "Approved" ? "green" : ""
              } `}
            >
              {row.stage}
            </div>
          );
        },
      },
      {
        dataField: "status",
        text: "Status",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <div className="status grey">
              <div className="d-flex">
                {row.status}
                <div className="lcIcon">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.5 6.375H12.75V4.875C12.75 2.805 11.07 1.125 9 1.125C6.93 1.125 5.25 2.805 5.25 4.875V6.375H4.5C3.675 6.375 3 7.05 3 7.875V15.375C3 16.2 3.675 16.875 4.5 16.875H13.5C14.325 16.875 15 16.2 15 15.375V7.875C15 7.05 14.325 6.375 13.5 6.375ZM6.75 4.875C6.75 3.63 7.755 2.625 9 2.625C10.245 2.625 11.25 3.63 11.25 4.875V6.375H6.75V4.875ZM13.5 15.375H4.5V7.875H13.5V15.375ZM9 13.125C9.825 13.125 10.5 12.45 10.5 11.625C10.5 10.8 9.825 10.125 9 10.125C8.175 10.125 7.5 10.8 7.5 11.625C7.5 12.45 8.175 13.125 9 13.125Z"
                      fill="#1D1E20"
                    />
                  </svg>
                </div>
              </div>
            </div>
          );
        },
      },
      {
        dataField: "",
        text: "",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <div className="action">
              <Button
                type="button"
                onClick={() =>
                  this.handleOperationalBudgetsdetails(row, rowIndex)
                }
              >
                View
              </Button>
            </div>
          );
        },
      },
    ];
    return (
      <div className="pl-budget">
        <Container fluid className="body-sec">
          <div className="page-heading underline d-flex">
            <HidSelector
              onClickEvent={this.selectHotelDropDown}
              ref={this.childHID}
              modulename={"Invoice"}
              extraSelector={this.state.updatePipOnly} // extraSelector = updatePipOnly = true means only calls hotel list API and updates pip and doesn't call onClickEvent function
            />
            <div className="mr-auto d-flex align-items-center">
              Operational Budgets
            </div>
            <div className="action-group d-flex">
              <Button type="button">Create New Budget</Button>
            </div>
          </div>
          <div className="bdy-sec">
            <ToolkitProvider keyField="rNo" data={data} columns={columns}>
              {(props: {
                searchProps: JSX.IntrinsicAttributes;
                baseProps: JSX.IntrinsicAttributes;
              }) => (
                <div>
                  <div className="filter-sec d-flex">
                    <div className="search-sec sec">
                      <Form.Control type="text" placeholder="Search" />
                    </div>
                    <div className="year-selector sec">
                      <SingleSelectDropDown
                        customClass={"common transparent single"}
                        placeholder={"Select Year"}
                        selectedValue={this.state.selectedYear}
                        items={this.state.dropdownItems}
                        onSelect={this.handleYearSelect}
                        disabled={false}
                      />
                    </div>
                    <div className="status-selector sec">
                      <MultiSelectDropDown
                        customClass={"common transparent multi"}
                        customHeight={"34"}
                        customPadding={"4"}
                        title="TotalStage"
                        items={items}
                        onChange={this.handleMultiSelectChange}
                      />
                    </div>
                    <div className="stage-selector sec">
                      <SingleSelectDropDown
                        customClass={"common transparent single"}
                        placeholder={"Select Stage"}
                        selectedValue={this.state.selectedStage}
                        items={this.state.StatusdropdownItems}
                        onSelect={this.handleStageSelect}
                      />
                    </div>
                  </div>
                  <div className="scroll-area">
                    <BootstrapTable {...props.baseProps} keyField="id" hover />
                  </div>
                </div>
              )}
            </ToolkitProvider>
          </div>
        </Container>
        {this.state.isOperationalBudgetsdetailsSlideOut && (
          <OperationalBudgetsDetails
            selectedYear={this.state.selectedYear}
            hidValue={this.state.hidValue}
            handleOperationalBudgetsDetailsModal={
              this.OperationalBudgetsDetailsModal
            }
          />
        )}
      </div>
    );
  }
}
